import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/[slug]/Article.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/components/BlogNav.tsx")